module.exports = __webpack_public_path__ + "img/portrait-four.a88311a0.png";